export var archiveUrl = 'https://sbn-ritel.kemenkeu.go.id/djpprapi/archives/';
export var serviceUrl = 'https://sbn-ritel.kemenkeu.go.id/djpprapi/api/';
export var reportUrl = 'https://sbn-ritel.kemenkeu.go.id/djpprapi/report/';

// export var archiveUrl = 'https://sbn-ritel.kemenkeu.go.id/sbndev/archives/';
// export var serviceUrl = 'https://sbn-ritel.kemenkeu.go.id/sbndev/api/';
// export var reportUrl = 'https://sbn-ritel.kemenkeu.go.id/sbndev/report/';

// export var archiveUrl = 'https://portal-djppr.kemenkeu.go.id/kong/sbnritelweb/archives/';
// export var serviceUrl = 'https://portal-djppr.kemenkeu.go.id/kong/sbnritelweb/api/';
// export var reportUrl = 'https://portal-djppr.kemenkeu.go.id/kong/sbnritelweb/report/';

// export var archiveUrl = 'https://portal-djppr.kemenkeu.go.id/kong/sbndev/archives/';
// export var serviceUrl = 'https://portal-djppr.kemenkeu.go.id/kong/sbndev/api/';
// export var reportUrl = 'https://portal-djppr.kemenkeu.go.id/kong/sbndev/report/';

// export var archiveUrl = 'http://10.100.83.91/djpprapi/archives/';
// export var serviceUrl = 'http://10.100.83.91/djpprapi/api/';
// export var reportUrl = 'http://10.100.83.91/djpprapi/report/';

// export var archiveUrl = 'http://10.100.83.205/djpprapi/archives/';
// export var serviceUrl = 'http://10.100.83.205/djpprapi/api/';
// export var reportUrl = 'http://10.100.83.205/djpprapi/report/';

// export var archiveUrl = 'http://localhost:23989/archives/';
// export var serviceUrl = 'http://localhost:23989/api/';
// export var reportUrl = 'http://localhost:23989/report/';

export var clearToken = function () {
    sessionStorage.removeItem('authorizationData');
    location.href = '';
}
export var successMessage = function () {
    return 'Data berhasil disimpan.';
}
export var errorMessage = function (err: any) {
    var message: string;
    switch (err.status) {
        case 0:
            message = '#' + err.status + ' Tidak terkoneksi dengan API service. Pastikan terhubung dengan jaringan internet.';
            break;
        case 400:
            message = err.json().Message;
            break;
        case 401:
            message = '#' + err.status + ' Unauthorized';
            sessionStorage.removeItem('authorizationData');
            sessionStorage.removeItem('profile');
            location.href = '';
            //location.reload();
            break;
        case 405:
            message = '#' + err.status + ' Method not allowed';
            break;
        case 422:
            message = '#' + err.status + ' Konfirmasi Bid NP';
            break;
        case 500:
            //message = '#' + err.status + ' Internal server error';
            //message =  'Periksa kembali file anda';
            message =  'Unknown Error';
            break;
        default:
            message = err.status;
            break;
    }
    return message;
}

export var formatDate = function (date: any) {
    var d = new Date(date || Date.now()),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}
export var formatDateTime = function (date: any) {
    var d = new Date(date || Date.now()),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-') + ' ' + d.getHours().toString() + ':' + d.getMinutes().toString();
}
export var formatDateTime2 = function (date: any) {
    var d = new Date(date || Date.now()),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-') + ' ' + d.getUTCHours().toString() + ':' + d.getMinutes().toString();
}
//export var getToken = function () {
//    var data = JSON.parse(sessionStorage.getItem('authorizationData'));
//    if (data == null) {
//        return false;
//    }
//    return data.token;
//}
export var getClientName = function () {
    var data = JSON.parse(sessionStorage.getItem('authorizationData'));
    if (data == null) {
        return false;
    }
    return data.clientName;
}
export var getNumber = function (val: any) {
    if (isNaN(val)) {
        return Number(val.replace(',', '').replace(',', '').replace(',', '').replace(',', '').replace(',', ''));
    } else {
        return val;
    }
}
export var menuActive = function (val: number, data: any) {
    var userProfile = data;
    if (userProfile == null) {
        return false;
    }
    for (var i = 0; i < userProfile.MAIN_MENU.length; i++) {
        for (var j = 0; j < userProfile.MAIN_MENU[i].CHILD_MENU.length; j++) {
            if (userProfile.MAIN_MENU[i].CHILD_MENU[j].MI_ID == val) {
                return true;
            }
        }
    }
    return false;
}
export var panelActive = function (val: number, data: any) {
    var userProfile = data;
    if (userProfile == null) {
        return false;
    }
    for (var i = 0; i < userProfile.CONTROL_PANEL.length; i++) {
        if (userProfile.CONTROL_PANEL[i].MI_ID == val) {
            return true;
        }
    }
    return false;
}
export var getAuthMenu = function (val: number, data: any) {
    var userProfile = data;
    if (userProfile == null) {
        return false;
    }
    for (var i = 0; i < userProfile.MAIN_MENU.length; i++) {
        for (var j = 0; j < userProfile.MAIN_MENU[i].CHILD_MENU.length; j++) {
            if (userProfile.MAIN_MENU[i].CHILD_MENU[j].MI_ID == val) {
                return userProfile.MAIN_MENU[i].CHILD_MENU[j];
            }
        }
    }
    return false;
    //location.href = '';
}
export var getAuthPanel = function (val: number, data: any) {
    var userProfile = data;
    if (userProfile == null) {
        return false;
    }
    for (var i = 0; i < userProfile.CONTROL_PANEL.length; i++) {
        if (userProfile.CONTROL_PANEL[i].MI_ID == val) {
            return userProfile.CONTROL_PANEL[i];
        }
    }
    return false;
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/globals.ts